import './css/styles.scss';

function allaVarumarkenInit() {}

allaVarumarkenInit();
